import {useIsAuthenticated} from "@/composables/useIsAuthenticated";
import {useI18n} from "vue-i18n";
import {useKMessageStore} from "@/components/dds/KMessageStore/KMessageStore";

const {authenticated} = useIsAuthenticated();

export interface IUseStatusHandler {
    handleLoginRedirect: (status: number) => Promise<void>
    handleStatus: (status: number, expected: number, message: string, throwErrorOnMissmatch?: boolean, plural?: number) => void
}

export const useStatusHandler = (): IUseStatusHandler => {
    const {t} = useI18n();
    const messageStore = useKMessageStore();
    const handleLoginRedirect = async (status: number) => {
        if (status === 401) {
            authenticated.value = false;
            // Redirect to SAML login; preserve /chat/ context so the
            // user returns to the chat PWA after re-authentication.
            const redirectTo = globalThis.location.pathname.startsWith('/chat') ? '/chat/' : '/'
            globalThis.location.href = '/saml/login?redirect_to=' + encodeURIComponent(redirectTo)
        }
        if (status === 403) {
            messageStore.push("error", t('errors.permissionError'));
        }

    }
    const handleStatus = (status: number, expected: number, message: string, throwErrorOnMissmatch?: boolean, plural?: number) => {
        if (status == expected){
            let msg: string;
            if (message){
                if (plural){
                    msg = t(message, plural)
                } else {
                    msg = t(message)
                }
                if (msg){
                    messageStore.push("success", msg);
                }
            }
        } else if (throwErrorOnMissmatch){
            throw new Error("wrong status")
        }
    }
    return {
        handleStatus,
        handleLoginRedirect
    }
}
